import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NbMenuItem } from '@nebular/theme';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { CatalogComponent } from './catalog.component';

export const catalogroutes: Routes = [
  {
    path:'',
    component:CatalogComponent,
    children:[
    {
      path:'catalog/:prodCatalogId',
      component:CatalogComponent,
      
    },
    {
      path:'catalog/:prodCatalogId/catalogs',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/paymentSettings',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/facilities',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/roles',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/promotions',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/shipmentMethods',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/shipmentCostEstimates',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/financialAccountSettings',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/storeEmailSettings',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/storeSurveys',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/vendorShipments',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/vendorPaymentSettings',
      component:CatalogComponent
    },
    {
      path:'catalog/:prodCatalogId/webSites',
      component:CatalogComponent
    }

    ]
  }
]
const MENU_ITEMS:NbMenuItem[] = [];
const headerTitle:string = "Catalog Management Application";
const path:string = "catalogs";
const menuTag:string = "catalogsMenu"

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(catalogroutes),
    UbsViewContainersModule
  ]
})
export class CatalogRoutingModule { 
  menuAndTitleOptions = {path:path,menuItems:MENU_ITEMS,headerTitle:headerTitle,menuTag:menuTag};
  constructor(private viewContainerService:ViewContainersService){
    this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(menuTag);
    //this.viewContainerService.addMenuAndTitleOptions(menuAndTitleOptions)
  }
}
